<template>
	<Sidebar :collapsible="isMobile ? 'offcanvas' : 'icon'">
		<SidebarHeader class="px-3 pt-8">
			<Logo class="h-6 w-auto md:pt-10 pb-3" />
		</SidebarHeader>

		<SidebarContent class="pt-3 md:pt-4">
			<SidebarGroup class="mt-2 md:mt-3">
				<SidebarMenu>
					<SidebarMenuItem>
						<RouterLink to="/cabinet" custom v-slot="{ href, navigate, isActive }">
							<a :href="href">
								<SidebarMenuButton :active="isActive" @click="navigate">
									<HomeIcon class="h-5 w-5" />
									<span>{{ $t('nav.home_link') }}</span>
								</SidebarMenuButton>
							</a>
						</RouterLink>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarGroup>
		</SidebarContent>

		<SidebarFooter class="mt-auto">
			<LocaleSwitcher v-if="isMobile" />
		</SidebarFooter>

		<SidebarRail />
	</Sidebar>
</template>

<script>
import Logo from '../../components/base/Logo.vue'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'
import LocaleSwitcher from '@vue-app/components/header/parts/LocaleSwitcher.vue'
import { mapState } from 'vuex'
import { CHANGE_SIDEBAR_PINNED } from '@vue-app/store/const/actions-types'
import {
	Sidebar,
	SidebarHeader,
	SidebarContent,
	SidebarFooter,
	SidebarRail,
	SidebarGroup,
	SidebarMenu,
	SidebarMenuItem,
	SidebarMenuButton,
} from '@ui/sidebar'
import { HomeIcon, PinIcon } from 'lucide-vue-next'

export default {
	name: 'HomeSidebar',
	components: {
		LocaleSwitcher,
		Logo,
		Sidebar,
		SidebarHeader,
		SidebarContent,
		SidebarFooter,
		SidebarRail,
		SidebarGroup,
		SidebarMenu,
		SidebarMenuItem,
		SidebarMenuButton,
		HomeIcon,
		PinIcon,
	},
	mixins: [responsiveMixin],
	computed: {
		...mapState(['sidebar']),
	},
	methods: {
		toggleSidebarPinned() {
			this.$store.commit(CHANGE_SIDEBAR_PINNED, !this.sidebar.pinned)
		},
	},
}
</script>
<style scoped>
[data-slot="sidebar"][data-state="collapsed"] :deep(.logo__text) {
	opacity: 0;
	width: 0;
	pointer-events: none;
}

[data-slot="sidebar"][data-state="expanded"] :deep(.logo__text) {
	opacity: 1;
	width: auto;
}

[data-slot="sidebar"][data-state="collapsed"] :deep(.logo__icon svg) {
	max-width: 23px;
	height: auto;
}
</style>
